"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IframeEditors = void 0;
const PermissionName_1 = require("../Permission/PermissionName");
const NativeFeatureIdentifier_1 = require("../Feature/NativeFeatureIdentifier");
const NoteType_1 = require("../Component/NoteType");
const FillEditorComponentDefaults_1 = require("./Utilities/FillEditorComponentDefaults");
const domain_core_1 = require("@standardnotes/domain-core");
const ProductNames_1 = require("../Strings/ProductNames");
const ttag_1 = require("ttag");
function IframeEditors() {
    const tokenvault = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
        name: ProductNames_1.AuthenticatorName,
        note_type: NoteType_1.NoteType.Authentication,
        file_type: 'json',
        interchangeable: false,
        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TokenVaultEditor,
        permission_name: PermissionName_1.PermissionName.TokenVaultEditor,
        description: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info')
            .t `Encrypt and protect your 2FA secrets for all your internet accounts. Authenticator handles your 2FA secrets so that you never lose them again, or have to start over when you get a new device.`,
        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/token-vault.png',
        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
    });
    const spreadsheets = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
        name: ProductNames_1.SpreadsheetName,
        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SheetsEditor,
        note_type: NoteType_1.NoteType.Spreadsheet,
        file_type: 'json',
        interchangeable: false,
        permission_name: PermissionName_1.PermissionName.SheetsEditor,
        description: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info')
            .t `A powerful spreadsheet editor with formatting and formula support. Not recommended for large data sets, as encryption of such data may decrease editor performance.`,
        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/spreadsheets.png',
        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
    });
    return [tokenvault, spreadsheets];
}
exports.IframeEditors = IframeEditors;
